export default "__VITE_ASSET__Cy$PA7NC__"